const typographicScale = {
  h1: '36px',
  h2: '30px',
  h3: '22px',
  h4: '18px',
  h5: '16px',
  h6: '14px',
  p: '14px',
  input: '16px',
};

if (!import.meta.env.PROD) {
  Object.freeze(typographicScale);
}

export type TypographicScale = Readonly<typeof typographicScale>;
export type TypographicScaleKeys = Readonly<keyof typeof typographicScale>;

export const applyTypographyOf: (element: TypographicScaleKeys) => string = (
  element: TypographicScaleKeys,
) => `
  font-size: ${typographicScale[element]};
`;

export default typographicScale;
